import script from "./Mobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Mobile.vue?vue&type=script&lang=ts&setup=true"

import "./Mobile.vue?vue&type=style&index=0&id=6de1143a&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de1143a"]])

export default __exports__